import React from 'react';
import { Modal } from '@common/Modal';
import { Circle, MapPin, Route } from 'lucide-react';
import { useSurvey } from '@contexts/SurveyContext';
import { formatDistance } from '@utils/routeHelpers';

export const RecordingStatsModal = ({ isOpen, onClose }) => {
  const { activeSurvey } = useSurvey();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Recording Status">
      <div className="p-6 space-y-6">
        {/* Survey Info */}
        <div className="bg-gray-700/50 p-4 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Circle className="w-5 h-5 text-red-500 animate-pulse" />
            <h3 className="font-medium text-white">Recording Active</h3>
          </div>
          <p className="text-gray-300">
            {activeSurvey?.name || 'No active survey'}
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-3 gap-4">
          <div className="bg-gray-700/50 p-4 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Route className="w-5 h-5 text-blue-400" />
              <span className="text-gray-300">Routes</span>
            </div>
            <span className="text-2xl font-bold text-white">
              {activeSurvey?.routes?.length || 0}
            </span>
          </div>

          <div className="bg-gray-700/50 p-4 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <MapPin className="w-5 h-5 text-green-400" />
              <span className="text-gray-300">POIs</span>
            </div>
            <span className="text-2xl font-bold text-white">
              {activeSurvey?.pois?.length || 0}
            </span>
          </div>

          <div className="bg-gray-700/50 p-4 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Route className="w-5 h-5 text-purple-400" />
              <span className="text-gray-300">Distance</span>
            </div>
            <span className="text-2xl font-bold text-white">
              {formatDistance(activeSurvey?.totalDistance || 0)}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};